(function () {
  var quoteUiReady = false;
  var quoteController = null;

  function initMotion(root) {
    if (!root || root.dataset.marketMotionReady === 'true') return;
    var targets = Array.prototype.slice.call(root.querySelectorAll('[data-motion]'));
    if (!targets.length) return;
    targets.forEach(function (target, index) {
      if (!target.style.getPropertyValue('--motion-index')) target.style.setProperty('--motion-index', String(index % 6));
    });
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (target) { target.classList.add('is-visible'); });
      root.dataset.marketMotionReady = 'true';
      return;
    }
    root.classList.add('smg-motion-ready');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    targets.forEach(function (target) { observer.observe(target); });
    root.senbederMarketGuidesMotionObserver = observer;
    root.dataset.marketMotionReady = 'true';
  }

  function money(value) {
    return '$' + (Number(value) || 0).toFixed(2);
  }

  function initProductRail(rail) {
    if (!rail || rail.dataset.marketRailReady === 'true') return;
    var track = rail.querySelector('[data-market-product-track]');
    var previous = rail.querySelector('[data-market-rail-prev]');
    var next = rail.querySelector('[data-market-rail-next]');
    if (!track || !previous || !next) return;

    rail.dataset.marketRailReady = 'true';

    function visibleCards() {
      return Array.prototype.filter.call(track.querySelectorAll('[data-market-product]'), function (card) { return !card.hidden; });
    }

    function scrollStep() {
      var card = visibleCards()[0];
      if (!card) return Math.max(240, track.clientWidth * .82);
      var styles = window.getComputedStyle(track);
      return card.getBoundingClientRect().width + (parseFloat(styles.columnGap || styles.gap) || 18);
    }

    function updateControls() {
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = maxScroll <= 2 || track.scrollLeft >= maxScroll - 2;
    }

    previous.addEventListener('click', function () { track.scrollBy({ left: -scrollStep(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: scrollStep(), behavior: 'smooth' }); });
    track.addEventListener('scroll', updateControls, { passive: true });
    rail.addEventListener('senbeder:market-filtered', function () {
      track.scrollTo({ left: 0, behavior: 'auto' });
      window.requestAnimationFrame(updateControls);
    });

    if ('ResizeObserver' in window) {
      rail.senbederMarketRailResizeObserver = new ResizeObserver(updateControls);
      rail.senbederMarketRailResizeObserver.observe(track);
    }

    window.requestAnimationFrame(updateControls);
  }

  function initQuoteUi() {
    var store = window.SenbederQuoteStore;
    var drawer = document.querySelector('[data-market-quote-drawer]');
    var overlay = document.querySelector('[data-market-quote-overlay]');
    if (!store || !drawer || !overlay || quoteUiReady) return;

    quoteUiReady = true;
    var list = drawer.querySelector('[data-market-quote-items]');
    var total = drawer.querySelector('[data-market-quote-total]');
    var empty = drawer.querySelector('[data-market-quote-empty]');
    var live = document.querySelector('[data-market-live]');
    var lastFocused = null;
    var closeTimer = null;
    quoteController = new AbortController();
    var signal = quoteController.signal;

    function renderBadges() {
      var count = store.count();
      document.querySelectorAll('[data-market-quote-count]').forEach(function (node) { node.textContent = String(count); });
    }

    function renderDrawer() {
      if (!list) return;
      var items = store.getItems();
      list.innerHTML = '';
      if (empty) empty.hidden = items.length > 0;
      items.forEach(function (item) {
        var row = document.createElement('article');
        row.className = 'smg-quote-item';
        if (item.image) {
          var image = document.createElement('img');
          image.src = item.image;
          image.alt = item.title || 'Motorcycle part added to the procurement list';
          image.loading = 'lazy';
          row.appendChild(image);
        }
        var copy = document.createElement('div');
        var title = document.createElement('strong');
        title.textContent = item.title;
        var meta = document.createElement('span');
        meta.textContent = [item.desc, item.unit ? 'Unit: ' + item.unit : '', item.moq ? 'MOQ: ' + item.moq : ''].filter(Boolean).join(' | ');
        copy.append(title, meta);
        var controls = document.createElement('div');
        controls.className = 'smg-quote-controls';
        var quantity = document.createElement('input');
        quantity.type = 'number';
        quantity.min = '1';
        quantity.value = String(item.qty);
        quantity.setAttribute('aria-label', 'Quantity for ' + item.title);
        quantity.addEventListener('input', function () { store.setQty(item.id, quantity.value, 'market-guides'); });
        var subtotal = document.createElement('span');
        subtotal.textContent = money(item.qty * item.price);
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = 'Remove';
        remove.addEventListener('click', function () { store.remove(item.id, 'market-guides'); });
        controls.append(quantity, subtotal, remove);
        row.append(copy, controls);
        list.appendChild(row);
      });
      if (total) total.textContent = money(store.total());
      renderBadges();
    }

    function openDrawer() {
      if (closeTimer) window.clearTimeout(closeTimer);
      lastFocused = document.activeElement;
      renderDrawer();
      drawer.hidden = false;
      overlay.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
      });
      document.documentElement.classList.add('smg-drawer-open');
      var closeButton = drawer.querySelector('[data-market-close-quote]');
      if (closeButton) closeButton.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.documentElement.classList.remove('smg-drawer-open');
      closeTimer = window.setTimeout(function () {
        drawer.hidden = true;
        overlay.hidden = true;
      }, 260);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function itemFromCard(card) {
      var owner = card.closest('[data-market-name]');
      return {
        id: card.dataset.productId,
        title: card.dataset.title,
        xbd: card.dataset.xbd,
        desc: card.dataset.desc,
        unit: card.dataset.unit,
        moq: card.dataset.moq,
        price: card.dataset.price,
        priceDisplay: card.dataset.priceDisplay,
        basePrice: card.dataset.basePrice,
        quotePricingVersion: card.dataset.quotePricingVersion,
        url: card.dataset.url,
        image: card.dataset.image,
        market: owner ? owner.dataset.marketName : ''
      };
    }

    document.addEventListener('click', function (event) {
      var addButton = event.target.closest('[data-market-add-quote]');
      if (addButton) {
        var card = addButton.closest('[data-market-product]');
        if (!card) return;
        var quantity = Math.max(1, Number(card.querySelector('[data-market-qty]')?.value) || 1);
        store.add(itemFromCard(card), quantity, 'market-guides');
        addButton.classList.add('is-added');
        addButton.textContent = 'Added to Quote';
        if (live) live.textContent = card.dataset.title + ' added to your quote list.';
        window.setTimeout(function () {
          addButton.classList.remove('is-added');
          addButton.textContent = addButton.dataset.defaultLabel || 'Add to Quote';
        }, 1800);
        return;
      }

      var filterButton = event.target.closest('[data-market-filter]');
      if (filterButton) {
        var filterOwner = filterButton.closest('[data-market-product-root]') || document;
        var filter = filterButton.dataset.marketFilter || 'all';
        filterOwner.querySelectorAll('[data-market-filter]').forEach(function (candidate) { candidate.setAttribute('aria-pressed', String(candidate === filterButton)); });
        filterOwner.querySelectorAll('[data-market-product]').forEach(function (card) { card.hidden = filter !== 'all' && card.dataset.category !== filter; });
        var productRail = filterOwner.querySelector('[data-market-product-rail]');
        if (productRail) productRail.dispatchEvent(new CustomEvent('senbeder:market-filtered'));
        return;
      }

      if (event.target.closest('[data-market-open-quote]')) {
        openDrawer();
        return;
      }
      if (event.target.closest('[data-market-close-quote]') || event.target === overlay) closeDrawer();
    }, { signal: signal });

    document.addEventListener('keydown', function (event) {
      if (drawer.hidden) return;
      if (event.key === 'Escape') { closeDrawer(); return; }
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])'));
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }, { signal: signal });

    window.addEventListener(store.changeEvent, renderDrawer, { signal: signal });
    window.addEventListener(store.openEvent, openDrawer, { signal: signal });
    renderDrawer();
  }

  function initAll() {
    document.querySelectorAll('.smg-root').forEach(initMotion);
    document.querySelectorAll('[data-market-product-rail]').forEach(initProductRail);
    initQuoteUi();
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    initMotion(event.target.querySelector('.smg-root') || event.target);
    event.target.querySelectorAll('[data-market-product-rail]').forEach(initProductRail);
    initQuoteUi();
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('.smg-root') || event.target;
    if (root.senbederMarketGuidesMotionObserver) root.senbederMarketGuidesMotionObserver.disconnect();
    event.target.querySelectorAll('[data-market-product-rail]').forEach(function (rail) {
      if (rail.senbederMarketRailResizeObserver) rail.senbederMarketRailResizeObserver.disconnect();
    });
    if (root.hasAttribute('data-market-guides-root') && quoteController) {
      quoteController.abort();
      quoteController = null;
      quoteUiReady = false;
    }
  });
})();
